/* =================== SLIDE HOME =================== */
$(function () {
  $(".carousel-slide").each(function () {
    // Elemento
    const $slide = $(this);

    // Total de itens no carrossel
    const totalItens = $slide.find(".splide__slide").length;

    // Intervalo
    let slideInterval = $slide.data("slide-interval") || 5000;

    // Opções gerais do slide
    let slideOpts = {
      type: "loop",
      perPage: 1,
      perMove: 1,
      autoplay: true,
      speed: 800,
      interval: slideInterval,
      pauseOnHover: true,
      arrows: true,
      pagination: true,
      lazyLoad: "nearby",
      breakpoints: {
        // Mobile
        768: {
          arrows: false,
        },
      },
    };

    // Efeito 'Fade' na transição
    const slideTransition = $slide.data("slide-transition");
    if (slideTransition === "fade") {
      slideOpts.type = "fade";
      slideOpts.rewind = true;
      slideOpts.speed = 1200;
    }

    // Habilite o auto height (Altura automática com base em cada slide)
    if ($slide.hasClass("carousel-autoheight")) {
      slideOpts.autoHeight = true;
      slideOpts.updateOnMove = true;
    }

    // Exibe barra de progresso
    const showProgress = $slide.data("slide-progress");
    if (showProgress) {
      $slide.append(
        `<div class="splide__progress"><div class="splide__progress__bar"></div></div>`
      );
    }

    // Ajusta para quando houver apenas um item no carrossel
    if (totalItens === 1) {
      slideOpts.type = "slide";
      slideOpts.arrows = false;
      slideOpts.pagination = false;
      slideOpts.drag = false;
      slideOpts.autoplay = false;
      slideOpts.keyboard = false;
    }

    // Inicia o slide
    let slide = new Splide($slide[0], slideOpts);

    // Configuração de animações com transições CSS
    function resetAllSlides() {
      $slide.find("[data-slide-animation]").each(function () {
        this.classList.remove("slide-anim-in");
        this.style.transitionDelay = "";
      });
    }

    function animateActiveSlide() {
      setTimeout(() => {
        // Seleciona todos os slides que possuem a classe .is-active (originais e clones)
        const activeSlides = $slide[0].querySelectorAll(".splide__slide.is-active");
        activeSlides.forEach(activeSlide => {
          // Anima os elementos do próprio slide ativo
          const els = activeSlide.querySelectorAll("[data-slide-animation]");
          els.forEach((el, i) => {
            el.style.transitionDelay = (i * 0.15) + "s";
            void el.offsetHeight;
            el.classList.add("slide-anim-in");
          });

          // Também anima todos os clones ou originais correspondentes que compartilham o mesmo index
          const activeIndex = activeSlide.getAttribute("data-splide-index");
          if (activeIndex !== null) {
            const matchingSlides = $slide[0].querySelectorAll(`.splide__slide[data-splide-index="${activeIndex}"]:not(.is-active)`);
            matchingSlides.forEach(slideEl => {
              const matchingEls = slideEl.querySelectorAll("[data-slide-animation]");
              matchingEls.forEach((el, i) => {
                el.style.transitionDelay = (i * 0.15) + "s";
                void el.offsetHeight;
                el.classList.add("slide-anim-in");
              });
            });
          }
        });
      }, 50);
    }

    // Registra os eventos do Splide
    slide.on("move", () => {
      resetAllSlides();
    });

    slide.on("moved", () => {
      animateActiveSlide();
    });

    slide.on("mounted", () => {
      resetAllSlides();
      animateActiveSlide();
    });

    // Monta o slide
    slide.mount();

    // Garantia de disparo inicial
    resetAllSlides();
    animateActiveSlide();
  });
});
